import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-650f8510"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue3Demo" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("隐藏或者显示demo组件")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改名字")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_demo = _resolveComponent("demo")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isShowDemo)
      ? (_openBlock(), _createBlock(_component_demo, {
          key: 0,
          name: '这是子组件传的参数',
          onReturnData: _ctx.returnData
        }, null, 8, ["onReturnData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowDemo = !_ctx.isShowDemo))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString(_ctx.name) + " ", 1),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_ctx.person.firstName) + " --- " + _toDisplayString(_ctx.person.lastName) + " ", 1),
    _hoisted_5,
    _createTextVNode(" " + _toDisplayString(_ctx.person.fullName) + " ", 1),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.person.fullName) = $event))
    }, null, 512), [
      [_vModelText, _ctx.person.fullName]
    ]),
    _hoisted_6,
    _createVNode(_component_el_button, { onClick: _ctx.changeName }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_8,
    _createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.num++))
    }, {
      default: _withCtx(() => [
        _createTextVNode("测试监听" + _toDisplayString(_ctx.num), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.msg+='!'))
    }, {
      default: _withCtx(() => [
        _createTextVNode("测试监听" + _toDisplayString(_ctx.msg), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.person.job.salary++))
    }, {
      default: _withCtx(() => [
        _createTextVNode("测试监听修改薪资" + _toDisplayString(_ctx.person.job.salary), 1)
      ]),
      _: 1
    }),
    _hoisted_9,
    _hoisted_10,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lastName) = $event))
    }, null, 512), [
      [_vModelText, _ctx.lastName]
    ])
  ]))
}